import React, { useReducer, createContext } from "react";

const initialState = {
  status: { Open: false, message: undefined },
};

const SnackBarContext = createContext({
  status: { Open: false },
  handleStatus: (userData) => {},
});

function SnackBarReducer(state, action) {
  switch (action.type) {
    case "STATUS": {
      return {
        ...state,
        status: action.payload,
      };
    }

    default:
      return state;
  }
}

function SnackBarProvider(props) {
  const [state, dispatch] = useReducer(SnackBarReducer, initialState);
  const handleStatus = (userData) => {
    dispatch({
      type: "STATUS",
      payload: userData,
    });
  };

  return (
    <SnackBarContext.Provider
      value={{ status: state, handleStatus }}
      {...props}
    />
  );
}

export { SnackBarContext, SnackBarProvider };
